import styled from "styled-components";

export const DealerResultWrapper = styled.li`
    display: flex;
    align-items: center;
    width: 100%;
    padding: var(--spacing-2);
    background-color: var(--color-primary-white);
    transition: background 0.3s;
    cursor: pointer;
    &:is(:hover, :focus) {
        background: var(--color-grey-1);
    }
`;

export const DealerResultEllipsis = styled.span`
    display: inline-block;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const DealerResultDistanceWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacing-1);
    color: var(--color-grey-7);
`;

export const DealerResultDistance = styled.span`
    font-family: var(--font-regular);
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: right;
    white-space: nowrap;
`;
